export default [
    {
        path: "/",
        meta: {
            requiresAuth: true,
            role: "admin",
            layout: "AdminLayout",
        },
        children: [
            {
                path: "admin-external-data-select",
                name: "admin-external-data-select",
                component: () =>
                    import("@/Pages/AdminExternalData/SelectSubModule.vue"),
                meta: { title: "Select External Data Type" },
            },
            {
                path: "admin-external-dashboard",
                component: () => import("@/Pages/AdminExternalData/Index.vue"),
                meta: {
                    requiresAuth: true,
                    role: "admin",
                    layout: "AdminLayout",
                },
                children: [
                    {
                        path: "",
                        name: "admin-external-dashboard",
                        component: () =>
                            import("@/Pages/AdminExternalData/Dashboard.vue"),
                        meta: { title: "Dashboard" },
                    },
                ],
            },
            {
                path: "admin-external-data",
                component: () => import("@/Pages/AdminExternalData/Index.vue"),
                meta: {
                    requiresAuth: true,
                    role: "admin",
                    layout: "AdminLayout",
                },
                children: [
                    {
                        path: "",
                        name: "admin-external-data",
                        component: () =>
                            import("@/Pages/AdminExternalData/List.vue"),
                        meta: { title: "External Data" },
                    },
                    {
                        path: "show/:id",
                        name: "admin-external-data-show",
                        component: () =>
                            import("@/Pages/AdminExternalData/Show.vue"),
                        meta: { title: "External Data Detail" },
                    },
                ],
            },
        ],
    },
];
